export default [
    {
        path: "/survey",
        component: () => import("@/Layouts/PublicLayout.vue"),
        children: [
            {
                path: "domestic-tourist",
                name: "domestic-tourist",
                component: () => import("@/Pages/PublicPage/Survey/Create.vue"),
                meta: { title: "Domestic Tourist Survey" },
            },
            {
                path: "transit-survey",
                name: "transit-survey",
                component: () => import("@/Pages/PublicPage/Survey/Create.vue"),
                meta: { title: "Domestic Tourist Survey" },
            },
            {
                path: "returning-bruneian",
                name: "returning-bruneian",
                component: () => import("@/Pages/PublicPage/Survey/Create.vue"),
                meta: { title: "Returning Bruneian Survey" },
            },
            {
                path: "exit-passenger",
                name: "exit-passenger",
                component: () => import("@/Pages/PublicPage/Survey/Create.vue"),
                meta: { title: "Exit Passenger Survey" },
            },
            {
                path: "next-travel",
                name: "next-travel",
                component: () => import("@/Pages/PublicPage/Survey/Create.vue"),
                meta: { title: "Next Travel Destination Survey" },
            },

            {
                path: "transit-survey/success",
                name: "transit-survey-success",
                component: () =>
                    import("@/Pages/PublicPage/Survey/Success.vue"),
                meta: { title: "Survey Submitted" },
            },
            {
                path: "domestic-tourist/success",
                name: "domestic-tourist-success",
                component: () =>
                    import("@/Pages/PublicPage/Survey/Success.vue"),
                meta: { title: "Survey Submitted" },
            },
            {
                path: "returning-bruneian/success",
                name: "returning-bruneian-success",
                component: () =>
                    import("@/Pages/PublicPage/Survey/Success.vue"),
                meta: { title: "Survey Submitted" },
            },
            {
                path: "exit-passenger/success",
                name: "exit-passenger-success",
                component: () =>
                    import("@/Pages/PublicPage/Survey/Success.vue"),
                meta: { title: "Survey Submitted" },
            },
            {
                path: "next-travel/success",
                name: "next-travel-success",
                component: () =>
                    import("@/Pages/PublicPage/Survey/Success.vue"),
                meta: { title: "Survey Submitted" },
            },
        ],
    },
];
